// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1348":"30fd5577","8125":"c214f31a"}[chunkId] + ".chunk.css";
};